import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const bonuses = [{
  tag: '🎁 Bonus n° 1',
  emoji: '🎥',
  title: 'PACK ARCADE EN CARTON',
  text: 'Une collection de vidéos amusantes qui montre, étape par étape, comment créer des jeux interactifs comme un mini-flipper, des roues de roulette personnalisées et des bornes d’arcade avec du simple carton et beaucoup d’imagination.',
  img: 'https://cdn.magicpatterns.com/uploads/rm6gShtDYvYzPFcSoGNy2X/IMG_1071.webp',
  price: '$25.00',
  tone: 'bg-sky-light',
  tagTone: 'bg-sky/20 text-sky'
}, {
  tag: '🎁 Bonus n° 2',
  emoji: '✂️',
  title: 'LE GUIDE DES LOISIRS CRÉATIFS EN 5 MINUTES',
  text: 'Votre guide de référence pour des créations rapides et sans désordre en papier et carton. Idéal les après-midis où vous n’avez pas de matériel spécial, mais cherchez une activité simple pour les éloigner des écrans.',
  img: 'https://cdn.magicpatterns.com/uploads/1CpLsWXtwqnmKgUPe3SsG4/IMG_1072.webp',
  price: '$19.00',
  tone: 'bg-sunshine-light',
  tagTone: 'bg-sunshine/30 text-ink'
}, {
  tag: '🎁 Bonus n° 3',
  emoji: '🌈',
  title: 'PETITS CRÉATEURS : SLIMES ET JEUX SENSORIELS',
  text: 'Un guide spécialisé rempli de recettes faciles de slime maison, pâte à modeler et textures sensorielles. Idéal pour occuper joyeusement les plus jeunes en créant avec leurs mains.',
  img: 'https://cdn.magicpatterns.com/uploads/dBr1uuNNizqi2RLuGzMBx2/IMG_1073.webp',
  price: '$19.00',
  tone: 'bg-coral-light',
  tagTone: 'bg-coral/20 text-coral'
}];
export function Bonuses() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-23" data-mp="33hfd2sl1nxyo">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-24" data-mp="33fulnbu10v51">
        <SectionHeading eyebrow="🎁 Bonus exclusifs" title={<>Commandez aujourd’hui et recevez ces 3 bonus offerts</>} subtitle="Obtenez MakerLab aujourd’hui et débloquez aussi ces 3 bonus exclusifs — à vous, sans frais supplémentaires." data-id="element-25" data-mp="np8denoybnmf" />
        <div className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-26" data-mp="3hhr81m3f8y0m">
          {bonuses.map((b, i) => <motion.article key={b.title} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={`flex flex-col overflow-hidden rounded-3xl border border-ink/10 ${b.tone}`} data-id="element-27" data-mp="3ljl4fi6l3fuz" data-mpi={i}>
              <div className="aspect-square w-full overflow-hidden border-b border-ink/10" data-id="element-28" data-mp="37lwkqdo96eri">
                <img src={b.img} alt={b.title} className="h-full w-full object-cover" data-id="element-29" data-mp="2a45z9r481hos" />
              </div>
              <div className="flex flex-1 flex-col p-6" data-id="element-30" data-mp="27iospmxwepip">
                <div className="mb-3 flex items-center justify-between" data-id="element-31" data-mp="22l6gnnol3u6h">
                  <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wide ${b.tagTone}`} data-id="element-32" data-mp="22itypaittjtf">
                    <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-33" data-mp="1tl090ifkhof8" />
                    {b.tag}
                  </span>
                  <span className="flex items-center gap-1.5 text-sm" data-id="element-34" data-mp="1omq95uiwdzna">
                    <span className="text-ink/40 line-through" data-id="element-35" data-mp="1jtdyypeytve2">{b.price}</span>
                    <span className="font-bold text-emerald-600" data-id="element-36" data-mp="1eusxkmnz95o1">OFFERT</span>
                  </span>
                </div>
                <h3 className="font-display text-lg font-bold leading-snug text-ink" data-id="element-37" data-mp="19xakck2xg4a8">
                  {b.emoji} {b.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/60" data-id="element-38" data-mp="15wgxzv54uxjg">
                  {b.text}
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}